import { generateKeyBetween } from "jittered-fractional-indexing";

type Key = string;

export const Ordering = { sortInPlace, toSorted, insertAt, compareKeys };

// replaced custom implementation designed/tested at https://jsfiddle.net/8430zyvj/
function insertAt<T>(items: T[], getKey: (item: T) => Key, idx: number) {
  if (idx < 0 || idx > items.length) {
    throw new Error(`Index ${idx} is out of bounds for array of length ${items.length}`);
  }
  if (idx === 0) {
    return generateKeyBetween(null, items.length > 0 ? getKey(items[0]) : null);
  }

  if (idx === items.length) {
    return generateKeyBetween(getKey(items[items.length - 1]), null);
  }

  const prevKey = getKey(items[idx - 1]);
  const nextKey = getKey(items[idx]);
  return generateKeyBetween(prevKey, nextKey);
}

function sortInPlace<T>(items: T[], getKey: (item: T) => Key) {
  items.sort((a, b) => {
    const keyA = getKey(a);
    const keyB = getKey(b);
    return compareKeys(keyA, keyB);
  });
  return items;
}

function toSorted<T>(items: T[], getKey: (item: T) => Key): T[] {
  return items.toSorted((a, b) => {
    const keyA = getKey(a);
    const keyB = getKey(b);
    return compareKeys(keyA, keyB);
  });
}

function compareKeys(a: Key, b: Key) {
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
}
